export default class Work {

    public readonly name: string
    public readonly section: string
    public readonly sold: boolean
    public readonly price: number

    constructor(
        name: string, 
        section: string, 
        sold: boolean,
        price: number
    ) {
        this.name = name
        this.section = section
        this.sold = sold
        this.price = price
    }
}
